import { Component, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EntityPagedRequestParameters, EntityOrderedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { Aviso, TIPOS_AVISO } from 'src/app/model/aviso.model';
import moment from "moment";
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { AvisoService } from './aviso.service';
import Utils from 'src/app/shared/fgi-utils';

@Component({
    selector: 'app-aviso-listagem',
    templateUrl: './aviso-listagem.component.html',
    styleUrls: ['./aviso-listagem.component.scss'],
    standalone: false
})
export class AvisoListagemComponent {
  private tiposAviso = TIPOS_AVISO;
  private agentesFinanceiros: AgenteFinanceiro[] = [];
  private dataHoraResultado: string;
  private atributosOrdenacao: EntityOrderedRequestParameters;
  public opcoesPaginacao: number[] = [10, 15, 20];

  @Input() podeCadastrarAviso:boolean = false;
  @Input() perfilAgente: Boolean = true;
  @Input() avisos: Aviso[];
  @Input() atributosPaginacao: EntityPagedRequestParameters;
  @Output() aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
  @Output() aoRequererDesativacao: EventEmitter<Aviso> = new EventEmitter<Aviso>();
  @Output() public exportarAvisos: EventEmitter<any> = new EventEmitter<any>();

  constructor(  private fileUtils: FileUtilsService,
                private avisoService: AvisoService,
                private activatedRoute: ActivatedRoute,) {
    this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes']; //resolver
    this.dataHoraResultado = moment().format('YYYY-MM-DD HH:mm:ss');
  }

  ngOnInit() {
    this.atributosOrdenacao = {
      atributo: '',
      sentido: 'asc'
    }
  }

  desativar(aviso: Aviso) {
    this.aoRequererDesativacao.emit(aviso);
  }

  exportarAnexo(aviso: Aviso) {
    this.avisoService.getAnexo(aviso.id).subscribe((conteudo) => {
        this.fileUtils.exportarArquivo(aviso.nomeAnexo, conteudo, FileUtilsService.APPLICATION_OCTEC);
    });
  }

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    this.avisos = this.avisos.sort((a, b) => {
      if (ord.sentido == "asc") {
        return this.compara(a, b, ord.atributo);
      }
      else {
        return -1 * this.compara(a, b, ord.atributo);
      }
    });
  }

  private compara(a, b, atributo): number {
    if (this.fetchFromObject(a, atributo) == this.fetchFromObject(b, atributo)) {
      return 0;
    }
    else {
      if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
        return 1;
      }
      else {
        return -1;
      }
    }
  }

  private fetchFromObject(obj, prop) {

    if(typeof obj === 'undefined') {
      return false;
    }

    var _index = prop.indexOf('.')
    if(_index > -1) {
        return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }

    return obj[prop];
  }

  public nomeTipoAviso(codigo: number) {
      const tipos = this.tiposAviso.filter(item => item.codigo == codigo);
      return tipos.length > 0 ? tipos[0].label : `Tipo de aviso para código '${codigo}' desconhecido.`;
  }

  public nomeAgente(id: number) {
    return Utils.nomeAgentePorId(id, this.agentesFinanceiros);
  } 

  btnExportarAvisos() {
    this.exportarAvisos.emit(null);
  }

}
